import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'addorganization',
	templateUrl: './addorganization.component.html',
	styleUrls: ['./addorganization.component.scss'],
})
export class AddOrganizationComponent implements OnInit {

  	loading: boolean = false;
  	showSpinner : boolean  = false;
	public form: FormGroup;
	public submitted = false;
    private countries: any[];
    private states: any[];
    private cities: any[];
    private selectedCountry: any;
    private selectedState: any;
	successMsg: any;
	alphabetPattern = /[a-zA-Z]/g;


	constructor(
		private auth: ApiCall,
		fb: FormBuilder,
		private toastr:ToastrService,
		private broadCast:BroadCastServiceService,
		public translate: TranslateService,
		private dialogRef: MatDialogRef<AddOrganizationComponent>,
	) {
		this.form = fb.group({
			organizationName: ['', [Validators.required]],
			// organizationEmail: ['', [Validators.required, Validators.email,
			//                         Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
			contactNumber: ['',],
			emailNotification: [false],
			userLimit: ['1', [Validators.required]],
			organizationAddress: fb.array([]),
		});
		const address = this.form.controls.organizationAddress as FormArray;
		address.push(fb.group({
			addressType: ['NONE',[Validators.required]],
			addressDetails: [''],
			country: [''],
			state: [''],
			city: [''],
			zipCode: [''],
		}));
	}

	ngOnInit(): void {
    	this.getAllCountries();
		// this.form.get('organizationEmail').valueChanges.subscribe((event) => {
		// 	this.form.get('organizationEmail').setValue(event.toLowerCase(), { emitEvent: false });
		// })
	}
	get f(): { [key: string]: AbstractControl } {
		return this.form.controls;
	}
	
  getAllCountries() {
    try {
      this.auth.getAllCountries().subscribe(
        (response: any) => {
          if (response.status === "SUCCESS") {
            this.countries = response.data;
          }
        },
        (error) => {
          console.error("API failed while getting all countries, ", error);
        }
      );
    } catch (error) {
      console.error("Error while getting all countries, ", error);
    }
  }

  getAllStates(countryId: any) {
    try {
      this.auth.getAllStatesByCountry(countryId).subscribe(
        (response: any) => {
          if (response.status === "SUCCESS") {
            this.states = response.data;
          }
        },
        (error) => {
          console.error("API failed while getting all states, ", error);
        }
      );
    } catch (error) {
      console.error("Error while getting all states, ", error);
    }
  }

  getAllCities(countryId: any, stateId: any) {
    try {
      this.auth.getCitiesByCountryAndState(countryId, stateId).subscribe(
        (response: any) => {
          if (response.status === "SUCCESS") {
            this.cities = response.data;
          }
        },
        (error) => {
          console.error("API failed while getting all cities, ", error);
        }
      );
    } catch (error) {
      console.error("Error while getting all cities, ", error);
    }
  }

  onCountryChange(value) {
    try {
      if (this.countries) {
        this.selectedCountry = this.countries.filter(country => country.name.toLowerCase() === value.toLowerCase())[0];
        if (this.selectedCountry) {
          this.getAllStates(this.selectedCountry.id);
        } else {
          this.states = [];
          this.cities = [];
        }
      }
    } catch (error) {
      console.error("Error occurred on country change, ", error);
    }
  }

  onStateChange(value) {
    try {
      if (this.states) {
        this.selectedState = this.states.filter(state => state.name.toLowerCase() === value.toLowerCase())[0];
        if (this.selectedState) {
          this.getAllCities(this.selectedState.countryId, this.selectedState.id);
        } else {
          this.cities = [];
        }
      }
    } catch (error) {
      console.error("Error occurred on state change, ", error);
    }
  }

	onSubmit(): void {
		try {
		this.loading = true;
		this.submitted = true;
		if (this.form.invalid) {
			this.loading = false;
			return;
		}
        let requestBody = {
            ...this.form.value,
            fixedLimit: this.form.value.userLimit
        }
		this.auth.addOrganization(requestBody).subscribe((res: any) => {
				if(res.data != null){
					this.dialogRef.close(false)
					this.broadCast.sendMessage('displayData');
					this.broadCast.sendMessage('organization'); 
					this.successMsg = res.message; 
					this.translate.get(['SUPER_ADMIN.ORGANIZATIONS.ADD_ORGANIZATION.SUCCESS_MSG'])
						.subscribe(translations => {
						this.successMsg = translations['SUPER_ADMIN.ORGANIZATIONS.ADD_ORGANIZATION.SUCCESS_MSG'];
					});
					this.toastr.success(this.successMsg, '', {
					  timeOut: 3000
					});
				  }
				  if(res.status === "FAIL"){
					this.toastr.error(res.message, '', {
					  timeOut: 3000
					});
				  }
		},(error) => {

		},() => {
		  this.loading = false; 
		})
		} catch {
			this.toastr.error('Error Occurred While Adding Organization.','',{
				timeOut:3000
				});
		}
	}

	close(): void {
		this.dialogRef.close(false)
	}

	keyPress(event: any) {
		const pattern = /[0-9 ]/;
	
		let inputChar = String.fromCharCode(event.charCode);
		if (event.keyCode != 8 && !pattern.test(inputChar)) {
		  event.preventDefault();
		}
	  }
	  onPaste(event: ClipboardEvent) {
		const clipboardData = event.clipboardData || (window as any).clipboardData;
		const pastedData = clipboardData.getData('text');
		if (this.alphabetPattern.test(pastedData)) {
		  event.preventDefault();
		}
	  }
	  cancel(): void {
		this.dialogRef.close(false);
	  }

	  clearForm(){
		this.form.reset();
	  }

	  getControls() {
		  return (this.form.get('organizationAddress') as FormArray).controls;
	  }

	  enforceMaxValue(input: HTMLInputElement) {
		const value = parseInt(input.value, 10);
		if (value > 10216) {
		  input.value = '10216';
		}
	  }  
}
